import {
  DeleteQuoteMutation,
  DeleteQuoteMutationVariables,
} from '../gql/graphql';
import { MutationHookOptions, useMutation } from '@apollo/client';

import { GET_QUOTES } from './quotes.query';
import { GET_RATER } from './rater.query';
import { GET_SUBMISSION } from './submission.query';
import { graphql } from '../gql';

export const DELETE_QUOTE = graphql(`
  mutation deleteQuote($quoteUuid: String!) {
    deleteQuote(quoteUuid: $quoteUuid) {
      result
    }
  }
`);

export function useDeleteQuoteMutation(
  options: MutationHookOptions<
    DeleteQuoteMutation,
    DeleteQuoteMutationVariables
  > = {}
) {
  const [deleteQuote, { loading, error, reset }] = useMutation(DELETE_QUOTE, {
    refetchQueries: [GET_QUOTES, GET_RATER, GET_SUBMISSION],
    ...options,
  });

  return {
    deleteQuote,
    loading,
    error,
    reset,
  };
}
